import {Component, OnDestroy} from '@angular/core';
import {Store} from '@ngrx/store';
import {AuthService, SwitchLanguageService} from '@pt/api-client';
import {PtCoreActions} from '@pt/pt-core';
import {PtUiAppRoutes} from '@pt/pt-models';
import {Subject} from 'rxjs';

@Component({
  selector: 'pt-forbidden',
  template: `
    <div class="w-100 h-100 auth-layout">
      <div class="image-content">
        <pt-auth-img-area></pt-auth-img-area>
      </div>
      <div class="form-content">
        <ng-container sign>
          <div class="forbidden-message-container">
            <div class="forbidden-message-form">
              <div class="forbidden">
                <p class="text-muted text-center mt-4" [innerText]="'MESSAGE.ERROR_OCCURRED' | translate"></p>
                <button class="btn btn-link btn-sm mt-3 mb-4" (click)="close()">{{'LABELS.BACK_TO_HOME' | translate}}</button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  `,
  styles: [`
    .forbidden-message-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100vh;
      overflow-x: hidden;
      overflow-y: hidden;
      padding: 10px 30px;
      background-color: #324f86;
    }

    .forbidden-message-container > * {
      width: 100%;
    }

    .forbidden-message-form {
      padding: 40px;
      border-radius: 4px;
      background-color: var(--bs-light);
    }

    .forbidden {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      height: 100%;
    }

    .auth-layout {
      display: grid;
      grid-template-columns: 1fr 400px;
      grid-template-rows: 1fr;
      gap: 0 0;
      grid-template-areas: "image-content form-content";
    }

    .form-content { grid-area: form-content;       overflow: hidden;}

    .image-content { grid-area: image-content;       overflow: hidden;}
  `]
})
export class ForbiddenComponent implements OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public switchLanguageService: SwitchLanguageService,
    private authService: AuthService,
    private store: Store) {
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  close() {
    this.store.dispatch(PtCoreActions.navigateTo({ route: [PtUiAppRoutes.HOME] }));
  }

}
